module.exports = __webpack_public_path__ + "img/panchito2.e3d13613.png";